module.exports = __webpack_public_path__ + "static/finding-my-leadership-voice-image-1-800x533-c8fe701a12085a1097b20b31d5990c4e.jpg";